import React, { useRef, useEffect } from 'react'
import { makeStyles, createStyles } from '@mui/styles'
import List from '@mui/material/List'
import { withRouter } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl'
import AppMenuItem from './appmenuitem'
import Divider from '@mui/material/Divider'
import { flattenMenuLinks, resolveActiveMenuLink } from './menuMatch'

const AppMenu = (props) => {
  const classes = useStyles();

  const appMenuItems = props.appMenuItems;

  // Fonte da verdade = rota atual. Resolve UMA vez qual link do menu está ativo (considerando
  // subrotas e telas internas via alias) e distribui para os itens marcarem/abrirem sozinhos.
  const pathname = props.location ? props.location.pathname : (typeof window !== 'undefined' ? window.location.pathname : '');
  const activeLink = resolveActiveMenuLink(pathname, flattenMenuLinks(appMenuItems));

  // Ao trocar de rota, rola o MENU até o item ativo, pra o usuário ver visualmente onde está.
  // O delay dá tempo do grupo-pai terminar de expandir (Collapse "auto") antes de medir a posição.
  const navRef = useRef(null);
  useEffect(() => {
    if (!activeLink) return undefined;
    const timer = setTimeout(() => {
      const container = navRef.current;
      if (!container || typeof container.querySelector !== 'function') return;
      const target = container.querySelector('.active') || container.querySelector('.active-parent');
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }, 400);
    return () => clearTimeout(timer);
  }, [activeLink]);

  return (
    <List component="nav" className={classes.appMenu} disablePadding ref={navRef}>
      {appMenuItems.map((item, index) => (
        (item.link != "divider") ? (
            <AppMenuItem {...item} key={index} activeLink={activeLink} />
        )
        :
         (
            <Divider   key={index} />
        )

      ))}
    </List>
  )
}

const drawerWidth = 240

const useStyles = makeStyles(theme =>
  createStyles({
    appMenu: {
      width: '100%',
      backgroundColor: 'var(--mexx-bg-primary)',
      padding: 'var(--space-2) 0',
    },
    navList: {
      width: drawerWidth,
    },
    menuItem: {
      width: drawerWidth,
    },
    menuItemIcon: {
      color: 'var(--mexx-green-primary)',
    },
  }),
)

export default injectIntl(withRouter(AppMenu))
